<template>
  <el-main id="admin-meeting-index">
    <h3 class="section-title green-left-head title-margin">総会管理</h3>
    <p>
      <el-row type="flex">
        <el-col :span="3">
          <el-button
            type="primary"
            icon="el-icon-circle-plus"
            @click="onEdit('new')"
            >新規総会</el-button
          >
        </el-col>
        <el-col :span="16">
          <el-button
            v-if="msAccount === null"
            type="success"
            icon="el-icon-user"
            @click="onMsLogin()"
            >マイクロソフトアカウントにログイン</el-button
          >
          <el-button
            v-else
            type="success"
            icon="el-icon-user"
            @click="onMsLogout()"
            >マイクロソフトアカウントからログアウト</el-button
          >
        </el-col>
      </el-row>
      <el-row v-if="msAccount === null">
        <el-col :offset="3"
          ><span class="teams-login-coution-message"
            >Teams総会をご利用の場合はマイクロソフトアカウントにログインしてください。</span
          >
        </el-col>
      </el-row>
    </p>
    <el-table :data="meetings" stripe style="width: 100%">
      <el-table-column label="公開"
        ><template slot-scope="scope">
          <span style="margin-left: 10px">{{
            scope.row.is_published ? "公開" : "非公開"
          }}</span>
        </template></el-table-column
      >
      <el-table-column prop="title" label="タイトル" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.is_teams" class="el-icon-s-custom"></span>
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="日付" width="180"
        ><template slot-scope="scope">
          <span style="margin-left: 10px">{{
            scope.row.date | moment("YYYY-MM-DD")
          }}</span>
        </template></el-table-column
      >
      <el-table-column prop="start_at" label="開始"> </el-table-column>
      <el-table-column prop="end_at" label="終了"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onEdit(scope.row._id)"
            >編集</el-button
          >
          <el-button
            v-if="scope.row.is_teams"
            type="text"
            size="small"
            class="el-icon-s-comment"
            @click="onTeamsMsg(scope.row._id)"
          >
            送信</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
import { mapState } from "vuex";
import store from "../../../store";

export default {
  name: "admin_meeting_index",
  async mounted() {
    // await this.$msal.handleRedirectPromise().then(
    //   function(res) {
    //     if (res !== null) {
    //       // ログイン済み
    //       this.$msal.setActiveAccount(res.account);
    //       this.$store.dispatch("msAccount/loginMsAccount", res.account);
    //     } else {
    //       // ログイン済みアカウントを確認
    //       var activeAccount = this.$msal.getActiveAccount();
    //       this.$store.dispatch("msAccount/loginMsAccount", activeAccount);
    //     }
    //   }.bind(this),
    // );
    // let account = this.$msal.getActiveAccount();
    // console.log(account);
    // if (account) {
    //   this.$store.dispatch("msAccount/loginMsAccount", account);
    // }
    await this.$store.dispatch("msAccount/initMsAccount");

    store.dispatch("meeting/all").then(
      // eslint-disable-next-line
      (docs) => {
        // console.log(docs);
      },
      // eslint-disable-next-line
      (error) => {
        // console.log(error);
      },
    );
  },
  beforeRouteEnter(to, from, next) {
    const currentUser = store.state.auth.user;
    console.log(currentUser);
    if (currentUser && !currentUser.permissions.includes("Admin")) {
      console.log(":401");
      next({ name: "notfound404" });
    } else {
      next();
    }
  },
  computed: {
    ...mapState({
      msAccount: function(state) {
        return state.msAccount.msAccount;
      },
    }),
    meetings() {
      console.log("MEETINGS");
      return this.$store.getters["meeting/meetings"];
    },
    showAdminBoard() {
      // console.log(this.currentUser.permissions);
      if (this.currentUser && this.currentUser.permissions) {
        return this.currentUser.permissions.includes["Director"];
      }

      return false;
    },
  },
  methods: {
    onEdit: function(id) {
      this.$router.push({ name: "admin_meeting_edit", params: { id } });
    },
    onTeamsMsg: function(id) {
      this.$router.push({ name: "admin_meeting_teams_send", params: { id } });
    },
    onMsLogin: async function() {
      // signinボタン黄貨
      console.log(process.env.VUE_APP_MS_SCOPES);
      await this.$msal
        .loginPopup({
          scopes: JSON.parse(process.env.VUE_APP_MS_SCOPES),
        })
        .then(
          async function(account) {
            console.log(account);
            this.$msal.setActiveAccount(account);
            console.log(account);
            if (account) {
              await this.$store.dispatch("msAccount/loginMsAccount", account);
            }
            await this.$store.dispatch("msAccount/initMsAccount");
            await store.dispatch("meeting/all");
          }.bind(this),
        );
    },
    onMsLogout: async function() {
      // let accounts = this.$msal.getAllAccounts();
      let activeAccount = this.$msal.getActiveAccount();
      if (!activeAccount) {
        let accounts = this.$msal.getAllAccounts();
        if (accounts.length > 0) {
          activeAccount = accounts[0];
        }
      }
      this.$msal
        .logoutPopup({
          account: activeAccount,
        })
        .then(
          function() {
            this.$store.dispatch("msAccount/logoutMsAccount");
            store.dispatch("meeting/all");
          }.bind(this),
        );
    },
  },
};
</script>

<style>
input {
  width: unset;
}
</style>
